import {
  APPARTMENT_CATEGORY_ID,
  COMMERCIAL_CATEGORY_ID,
} from "../clientConfig";
import { InfoMenuListOption } from "../types";
import {
  ADMIN_ROUTES,
  AGENT_ROUTES,
  BUILDER_ROUTES,
  SALES_ROUTES,
  USER_ROUTES,
} from "./appRoutes";

export const ALLOWED_VIDEO_TYPES = ["video/mp4", "video/mov", "video/webm"];
export const ALLOWED_IMAGES_TYPES = [
  "image/png",
  "image/jpg",
  "image/jpeg",
  "image/webp",
];

export const ROLES = {
  ADMIN: "ADMIN",
  STAFF: "STAFF",
  BUILDER: "BUILDER",
  AGENT: "AGENT",
  CUSTOMER: "CUSTOMER",
  SELLER: "SELLER",
  SALES: "SALES",
};

export const SELLER_ROLE = {
  BUILDER: "BUILDER",
  AGENT: "AGENT",
  BROKER: "BROKER",
  OWNER: "OWNER",
};

export const ROLES_ID = {
  ADMIN: 1,
  AGENT: 2,
  BUILDER: 3,
  CUSTOMER: 4,
  SELLER: 5,
  STAFF: 6,
  SALES: 7,
};

export const MODARATION_STATUS = [
  "Pending",
  "Approve",
  "Reject",
  "Deleted",
  "Sold",
];

export const CUSTOMER_TYPES = [
  { value: 4, label: "Buyer" },
  { value: 5, label: "Seller" },
];

export const SELLER_TYPES = [
  { value: 1, label: "Builder" },
  // { value: 2, label: "Broker" },
  { value: 3, label: "Agent / Broker" },
  { value: 4, label: "Owner" },
];

export const APPLICATION_ACCESS = {
  1: { type: ROLES.ADMIN, access: ROLES.ADMIN },
  3: { type: ROLES.BUILDER, access: ROLES.BUILDER },
  2: { type: ROLES.AGENT, access: ROLES.AGENT },
  4: { type: ROLES.CUSTOMER, access: ROLES.CUSTOMER },
  5: {
    1: { type: "SELLER", access: "BUILDER" },
    2: { type: "SELLER", access: "BROKER" },
    3: { type: "SELLER", access: "AGENT" },
    4: { type: "SELLER", access: "OWNER" },
  },
};

export const TOAST_TYPE = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
  INFO: "info",
};

export const TOAST_POSITION = {
  TOP_RIGHT: "top-right",
  TOP_LEFT: "top-left",
  TOP_CENTER: "top-center",
  BOTTOM_RIGHT: "bottom-right",
  BOTTOM_LEFT: "bottom-left",
  BOTTOM_CENTER: "bottom-center",
};

export const STATUS_OPTIONS = [
  { value: 0, label: "Unpublish" },
  { value: 1, label: "Publish" },
];

export const MODARATION_STATUS_OPTIONS = [
  { value: 0, label: "Pending" },
  { value: 1, label: "Approve" },
  { value: 2, label: "Reject" },
  { value: 3, label: "Draft" },
];

export const DEFAULT_MODERATION_STATUS_LIST: any = [
  { value: 0, label: "Pending", status: "pending" },
  { value: 1, label: "Approve", status: "success" },
  { value: 2, label: "Reject", status: "danger" },
  { value: 3, label: "Draft", status: "scheduled" },
  { value: 4, label: "Deleted", status: "danger" },
];

export const WHATSAPP_STATUS_LIST: any = [
  { value: "sent", label: "Sent", status: "pending" },
  { value: "delivered", label: "Delivered", status: "scheduled" },
  { value: "read", label: "Read", status: "success" },
  { value: "failed", label: "Failed", status: "danger" },
];

export const PROPERTY_FACING_OTPIONS = [
  { value: "east", label: "East" },
  { value: "west", label: "West" },
  { value: "south", label: "South" },
  { value: "north", label: "North" },
];

export const PROPERTY_OVERLOOKING_OPTIONS = [
  { value: 0, label: "Garden" },
  { value: 1, label: "Road" },
  { value: 2, label: "Park" },
];

export const PROPERTY_STATUS = [
  { value: 0, label: "Under Construction" },
  { value: 1, label: "Ready to move" },
  { value: 2, label: "Pre Launch" },
];

export const TAX_STATUS = [
  { label: "Yes", value: 0 },
  { label: "No", value: 1 },
];

export const REELS_MODERATION_STATUS = [
  { label: "Pending", value: 0 },
  { label: "Approved", value: 1 },
  { label: "Rejected", value: 2 },
];

export const FURNISHED_STATUS = [
  { label: "Fully Furnished", value: 2 },
  { label: "Semi Furnished", value: 1 },
  { label: "Unfurnished", value: 0 },
];

export const BUILDING_TYPES = [
  { label: "1 BHK", value: 1 },
  { label: "1.5 BHK", value: 1.5 },
  { label: "2 BHK", value: 2 },
  { label: "2.5 BHK", value: 2.5 },
  { label: "3 BHK", value: 3 },
  { label: "3.5 BHK", value: 3.5 },
  { label: "4 BHK", value: 4 },
  { label: "4.5 BHK", value: 4.5 },
  { label: "5 BHK", value: 5 },
  { label: "5.5 BHK", value: 5.5 },
  { label: "6 BHK", value: 6 },
  { label: "6.5 BHK", value: 6.5 },
  { label: "7 BHK", value: 7 },
  { label: "Commercial", value: 0 },
];

export const SALES_BUILDING_TYPES = [
  { label: "1 BHK", value: 1 },
  { label: "2 BHK", value: 2 },
  { label: "3 BHK", value: 3 },
  { label: "4 BHK", value: 4 },
  { label: "5 BHK", value: 5 },
  { label: "6 BHK", value: 6 },
  { label: "7 BHK", value: 7 },
  { label: "Commercial", value: 0 },
  { label: "Duplex", value: 8 },
];

export const PROJECT_TYPE = [
  { label: "Row House", value: 0 },
  { label: "Tower", value: 1 },
];

export const ADMIN_NAVBAR_DROPDOWN_MENUITEMS = [
  {
    key: "profile",
    value: "Profile",
    iconName: "profile",
  },
  {
    key: "logout",
    value: "Logout",
    iconName: "logout",
  },
];

export const BUILDER_SIDEBAR_ITEMS = [
  {
    name: "Dashboard",
    url: BUILDER_ROUTES.DASHBOARD,
    icon: "home",
    menuKey: "main",
  },
  {
    name: "Properties",
    url: `${BUILDER_ROUTES.ROOT}/${BUILDER_ROUTES.PROPERTIES}`,
    icon: "hotel",
    menuKey: "properties",
  },
  {
    name: "Projects",
    url: `${BUILDER_ROUTES.ROOT}/${BUILDER_ROUTES.PROJECTS}`,
    icon: "project-icon",
    menuKey: "projects",
  },
  {
    name: "Meetings",
    url: `${BUILDER_ROUTES.ROOT}/${BUILDER_ROUTES.MEETINGS}`,
    icon: "contact-us",
    menuKey: "meetings",
  },
  {
    name: "Enquiry",
    url: `${BUILDER_ROUTES.ROOT}/${BUILDER_ROUTES.ENQUIRY}`,
    icon: "enquiry",
    menuKey: "enquiry",
  },
  {
    name: "Agent",
    url: `${BUILDER_ROUTES.ROOT}/${BUILDER_ROUTES.AGENT}`,
    icon: "agent",
    menuKey: "agent",
  },
  {
    name: "Sales Team",
    url: `${BUILDER_ROUTES.ROOT}/${BUILDER_ROUTES.SALES_TEAM}`,
    icon: "sales-team",
    menuKey: "sales-team",
  },
  {
    name: "Leads",
    url: `${BUILDER_ROUTES.ROOT}/${BUILDER_ROUTES.LEADS}`,
    icon: "lead-icon",
    menuKey: "leads",
  },
  {
    name: "Reports",
    icon: "report",
    url: `${BUILDER_ROUTES.ROOT}/${BUILDER_ROUTES.REPORTS_PROPERTY_LIST}`,
    menuKey: "reports",
    // children: [
    //   {
    //     name: "Property Reports",
    //     url: `${BUILDER_ROUTES.ROOT}/${BUILDER_ROUTES.REPORTS_PROPERTY_LIST}`,
    //     icon: "userRoles",
    //     className: "all-staff",
    //   },
    //   {
    //     name: "Project Reports",
    //     url: `${BUILDER_ROUTES.ROOT}/${BUILDER_ROUTES.REPORTS_PROJECT_LIST}`,
    //     icon: "allStaff",
    //     className: "all-staff",
    //   },
    // ],
  },
];

export const SALES_SIDEBAR_ITEMS = [
  {
    name: "Dashboard",
    url: SALES_ROUTES.DASHBOARD,
    icon: "home",
    menuKey: "main",
  },
  {
    name: "Enquiry",
    url: `${SALES_ROUTES.ROOT}/${SALES_ROUTES.ENQUIRY}`,
    icon: "enquiry",
    menuKey: "enquiry",
  },
  {
    name: "Drone View",
    url: `${SALES_ROUTES.ROOT}/${SALES_ROUTES.DRONE_VIEW}`,
    icon: "drone",
    menuKey: "drone-view",
  },
];

export const ADMIN_SIDEBAR_ITEMS = [
  {
    name: "Dashboard",
    url: ADMIN_ROUTES.ROOT,
    icon: "dashboard",
    menuKey: "main",
  },
  {
    name: "Categories",
    url: `${ADMIN_ROUTES.ROOT}/${ADMIN_ROUTES.CATEGORY_MAIN_CATEGORIES}`,
    icon: "categories",
    menuKey: "categories",
  },
  {
    name: "Real Estate",
    icon: "hotel",
    url: `${ADMIN_ROUTES.ROOT}/${ADMIN_ROUTES.REAL_ESTATE_PROPERTIES}`,
    menuKey: "real-estate",
  },
  {
    name: "Agent",
    url: `${ADMIN_ROUTES.ROOT}/${ADMIN_ROUTES.AGENT}`,
    icon: "agent",
    menuKey: "agent",
  },
  {
    name: "Builders",
    url: `${ADMIN_ROUTES.ROOT}/${ADMIN_ROUTES.BUILDERS}`,
    icon: "builders",
    menuKey: "builders",
  },
  {
    name: "Sales Team",
    url: `${ADMIN_ROUTES.ROOT}/${ADMIN_ROUTES.SALES_TEAM}`,
    icon: "sales-team-dashboard",
    menuKey: "sales-team",
  },
  {
    name: "Leads",
    url: `${ADMIN_ROUTES.ROOT}/${ADMIN_ROUTES.LEADS}`,
    icon: "agent",
    menuKey: "leads",
  },
  {
    name: "Customer",
    url: `${ADMIN_ROUTES.ROOT}/${ADMIN_ROUTES.CUSTOMER}`,
    icon: "team",
    menuKey: "customer",
  },
  {
    name: "Manage Staff",
    icon: "staff",
    url: `${ADMIN_ROUTES.ROOT}/${ADMIN_ROUTES.MANAGE_STAFF_ROLES}`,
    menuKey: "manage-staff",
    // children: [
    //   {
    //     name: "Roles",
    //     url: `${ADMIN_ROUTES.ROOT}/${ADMIN_ROUTES.MANAGE_STAFF_ROLES}`,
    //     icon: "userRoles",
    //     className: "all-staff",
    //   },
    //   {
    //     name: "All Staff",
    //     url: `${ADMIN_ROUTES.ROOT}/${ADMIN_ROUTES.MANAGE_STAFF}`,
    //     icon: "allStaff",
    //     className: "all-staff",
    //   },
    // ],
  },
  {
    name: "Content Management",
    url: `${ADMIN_ROUTES.ROOT}/${ADMIN_ROUTES.CONTENT_MANAGEMENT_FAQS}`,
    icon: "manage-search",
    menuKey: "content-management",
  },
  {
    name: "Blog Post",
    url: `${ADMIN_ROUTES.ROOT}/${ADMIN_ROUTES.BLOG_POST}`,
    icon: "blog",
    menuKey: "blog-post",
  },
  {
    name: "Reels",
    url: `${ADMIN_ROUTES.ROOT}/${ADMIN_ROUTES.REELS}`,
    icon: "reels",
    menuKey: "reels",
  },
  {
    name: "Enquiry",
    url: `${ADMIN_ROUTES.ROOT}/${ADMIN_ROUTES.ENQUIRY}`,
    icon: "enquiry",
    menuKey: "enquiry",
  },
  {
    name: "Reports",
    icon: "report",
    url: `${ADMIN_ROUTES.ROOT}/${ADMIN_ROUTES.REPORTS_PROPERTY_LIST}`,
    menuKey: "reports",
  },
  {
    name: "Notification",
    url: `${ADMIN_ROUTES.ROOT}/${ADMIN_ROUTES.NOTIFICATION}`,
    icon: "notification",
    menuKey: "notification",
  },
  {
    name: "Feedback",
    url: `${ADMIN_ROUTES.ROOT}/${ADMIN_ROUTES.FEEDBACK}`,
    icon: "feedback",
    menuKey: "feedback",
  },
  {
    name: "Advertise",
    url: `${ADMIN_ROUTES.ROOT}/${ADMIN_ROUTES.ADVERTISE}`,
    icon: "advertise",
    menuKey: "advertise",
  },
  {
    name: "Whatsapp Analytics",
    url: `${ADMIN_ROUTES.ROOT}/${ADMIN_ROUTES.WHATS_APP_ANALYTICS}`,
    icon: "whats-app-icon",
    menuKey: "whatsapp-analytics",
  },
  {
    name: "Contact Us",
    url: `${ADMIN_ROUTES.ROOT}/${ADMIN_ROUTES.CONTACT}`,
    icon: "contact-us",
    menuKey: "contact",
  },
  {
    name: "SEO",
    url: `${ADMIN_ROUTES.ROOT}/${ADMIN_ROUTES.SEO}`,
    icon: "seo-icon",
    menuKey: "seo",
  },
  {
    name: "Sales Records",
    url: `${ADMIN_ROUTES.ROOT}/${ADMIN_ROUTES.SALES_RECORDS}`,
    icon: "sales-report",
    menuKey: "Sales-records",
  },
  {
    name: "Book Call",
    url: `${ADMIN_ROUTES.ROOT}/${ADMIN_ROUTES.BOOK_CALL_LIST}`,
    icon: "Interested",
    menuKey: "Book-call",
  },
];

export const AGENT_SIDEBAR_ITEMS = [
  {
    name: "Dashboard",
    url: AGENT_ROUTES.ROOT,
    icon: "home",
    menuKey: "main",
  },
  {
    name: "Project",
    url: `${AGENT_ROUTES.ROOT}/${AGENT_ROUTES.PROJECTS}`,
    icon: "project-icon",
    menuKey: "projects",
  },
  {
    name: "Properties",
    url: `${AGENT_ROUTES.ROOT}/${AGENT_ROUTES.PROPERTIES}`,
    icon: "property-icon",
    menuKey: "properties",
  },
  {
    name: "Meetings",
    url: `${AGENT_ROUTES.ROOT}/${AGENT_ROUTES.MEETINGS}`,
    icon: "meeting-icon",
    menuKey: "meetings",
  },
  {
    name: "Availability",
    url: `${AGENT_ROUTES.ROOT}/${AGENT_ROUTES.AVAILABILITY}`,
    icon: "availability-icon",
    menuKey: "availability",
  },
  {
    name: "Enquiry",
    url: `${AGENT_ROUTES.ROOT}/${AGENT_ROUTES.ENQUIRY}`,
    icon: "enquiry",
    menuKey: "enquiry",
  },
  {
    name: "Reports",
    icon: "report",
    url: `${AGENT_ROUTES.ROOT}/${AGENT_ROUTES.REPORTS_PROPERTY_LIST}`,
    menuKey: "reports",
    // children: [
    //   {
    //     name: "Property Reports",
    //     url: `${AGENT_ROUTES.ROOT}/${AGENT_ROUTES.REPORTS_PROPERTY_LIST}`,
    //     icon: "userRoles",
    //     className: "all-staff",
    //   },
    //   {
    //     name: "Project Reports",
    //     url: `${AGENT_ROUTES.ROOT}/${AGENT_ROUTES.REPORTS_PROJECT_LIST}`,
    //     icon: "allStaff",
    //     className: "all-staff",
    //   },
    // ],
  },
];

export const CUSTOMER_USER_DROPDOWN_OPTIONS = [
  {
    key: "navigate",
    value: "Saved Property",
    url: `${USER_ROUTES.SAVED_PROPERTY}`,
  },
  {
    key: "saved_project",
    value: "Saved Project",
    url: `${USER_ROUTES.SAVED_PROJECT}`,
  },
  {
    key: "navigate",
    value: "Saved Searches",
    url: `${USER_ROUTES.SAVED_SEARCHES}`,
  },
  {
    key: "navigate",
    value: "Manage Tours",
    url: `${USER_ROUTES.MANAGE_TOURS}`,
  },
  {
    key: "navigate",
    value: "Recently Viewed",
    url: `${USER_ROUTES.RECENTLY_VIEWED}`,
  },
  {
    key: "navigate",
    value: "Your Property",
    url: `${USER_ROUTES.YOUR_PROPERTY}`,
  },
  {
    key: "navigate",
    value: "Your Project",
    url: `${USER_ROUTES.YOUR_PROJECT}`,
  },
  {
    key: "setting",
    value: "Settings",
    url: `${USER_ROUTES.ACCOUNT_SETTINGS}`,
  },
  {
    key: "logout",
    value: "Logout",
    iconName: "logout",
  },
];

export const MENULIST_SECTION_USER_ACCOUNT_OPTIONS = [
  {
    label: "Saved Property",
    url: `${USER_ROUTES.SAVED_PROPERTY}`,
    access: [ROLES.CUSTOMER, ROLES.SELLER],
    seller: [SELLER_ROLE.BUILDER, SELLER_ROLE.AGENT, SELLER_ROLE.OWNER],
  },
  {
    label: "Saved Project",
    url: `${USER_ROUTES.SAVED_PROJECT}`,
    access: [ROLES.CUSTOMER, ROLES.SELLER],
    seller: [SELLER_ROLE.BUILDER, SELLER_ROLE.AGENT, SELLER_ROLE.OWNER],
  },
  {
    label: "Manage Tours",
    url: `${USER_ROUTES.MANAGE_TOURS}`,
    access: [ROLES.CUSTOMER, ROLES.SELLER],
    seller: [SELLER_ROLE.BUILDER, SELLER_ROLE.AGENT, SELLER_ROLE.OWNER],
  },
  {
    label: "Recently Viewed",
    url: `${USER_ROUTES.RECENTLY_VIEWED}`,
    access: [ROLES.CUSTOMER, ROLES.SELLER],
    seller: [
      SELLER_ROLE.BUILDER,
      SELLER_ROLE.AGENT,
      SELLER_ROLE.BROKER,
      SELLER_ROLE.OWNER,
    ],
  },
  {
    label: "Your Property",
    url: `${USER_ROUTES.YOUR_PROPERTY}`,
    access: [ROLES.BUILDER, ROLES.AGENT, ROLES.SELLER],
    seller: [SELLER_ROLE.BUILDER, SELLER_ROLE.AGENT, SELLER_ROLE.OWNER],
  },
  {
    label: "Your Project",
    url: `${USER_ROUTES.YOUR_PROJECT}`,
    access: [ROLES.BUILDER, ROLES.SELLER],
    seller: [SELLER_ROLE.BUILDER],
  },
  {
    label: "Archived Property",
    url: `${USER_ROUTES.ARCHIVED_PROPERTY}`,
    access: [ROLES.BUILDER, ROLES.AGENT, ROLES.SELLER],
    seller: [SELLER_ROLE.BUILDER, SELLER_ROLE.AGENT, SELLER_ROLE.OWNER],
  },
  {
    label: "Archived Project",
    url: `${USER_ROUTES.ARCHIVED_PROJECT}`,
    access: [ROLES.BUILDER, ROLES.AGENT, ROLES.SELLER],
    seller: [SELLER_ROLE.BUILDER],
  },
  {
    label: "Account Settings",
    url: `${USER_ROUTES.ACCOUNT_SETTINGS}`,
    access: [ROLES.CUSTOMER, ROLES.SELLER, ROLES.BUILDER, ROLES.AGENT],
    seller: [
      SELLER_ROLE.BUILDER,
      SELLER_ROLE.AGENT,
      SELLER_ROLE.BROKER,
      SELLER_ROLE.OWNER,
    ],
  },
];

export const CUSTOMER_NAVBAR_LIST = [
  {
    label: "Buy",
    url: "",
    side: "left",
    access: ["EVERYONE"],
    subMenu: [
      {
        section: "Popular Choices",
        menuList: [
          {
            url: `${USER_ROUTES.SEARCH}?status=1`,
            label: "Ready To Move",
            access: ["EVERYONE"],
          },
          {
            url: `${USER_ROUTES.SEARCH}?status=0`,
            label: "Under Construction",
            access: ["EVERYONE"],
          },
          {
            url: USER_ROUTES.YOUR_NEW_PROJECT,
            label: "New Projects",
            access: [ROLES.BUILDER, ROLES.SELLER],
            seller: [SELLER_ROLE.BUILDER],
          },
        ],
      },
      {
        section: "Property Type",
        menuList: [
          {
            url: `${USER_ROUTES.SEARCH}?category_id=${APPARTMENT_CATEGORY_ID}`,
            label: "Apartment",
            access: ["EVERYONE"],
          },
          {
            url: `${USER_ROUTES.SEARCH}?category_id=${COMMERCIAL_CATEGORY_ID}`,
            label: "Commercial",
            access: ["EVERYONE"],
          },
        ],
      },
    ],
  },
  {
    label: "Sell",
    url: USER_ROUTES.YOUR_PROPERTY,
    side: "left",
    access: [ROLES.BUILDER, ROLES.AGENT, ROLES.SELLER],
    seller: [SELLER_ROLE.BUILDER],
    subMenu: [],
  },
  {
    label: "Collaborations",
    url: USER_ROUTES.REELS,
    side: "left",
    access: ["EVERYONE"],
    subMenu: [],
  },
  {
    label: "Advertise",
    url: USER_ROUTES.MENU_ADVERTISE,
    side: "right",
    access: ["EVERYONE"],
    subMenu: [],
  },
  {
    label: "Help",
    url: USER_ROUTES.HELP_CENTER,
    side: "right",
    access: ["EVERYONE"],
    subMenu: [],
  },
];

export const CUSTOMER_NORMAL_FOOTER_ITEMS = [
  { url: USER_ROUTES.ABOUT_US, label: "About Us" },
  { url: USER_ROUTES.CONTACT_US, label: "Contact Us" },
  { url: USER_ROUTES.BLOG_LIST, label: "Blogs" },
  { url: USER_ROUTES.EMI_CALCULATOR, label: "EMI Calculator" },
  { url: USER_ROUTES.YOUR_PROPERTY, label: "Post your property" },
  { url: USER_ROUTES.USER_AGREEMENT, label: "User Agreement" },
  { url: USER_ROUTES.TERM_AND_CONDITIONS, label: "Terms & Conditions" },
  { url: USER_ROUTES.PRIVACY_POLICY, label: "Privacy Policy" },
  // { url: USER_ROUTES.ROOT, label: "Careers" },
  // { url: USER_ROUTES.ROOT, label: "Sales Enquiry" },
  { url: USER_ROUTES.HELP_CENTER, label: "Help Center" },
];

export const SOCIAL_MEDIA = [
  {
    url: "https://www.facebook.com/savitarrealty/",
    iconName: "social-facebook",
  },
  { url: "https://x.com/Savitarrealty", iconName: "social-twitter" },
  {
    url: "https://www.linkedin.com/company/savitar-realty/",
    iconName: "social-linkedIn",
  },
  {
    url: "https://www.instagram.com/savitar_realty/",
    iconName: "social-instagram",
  },
  {
    url: "https://www.youtube.com/@SavitarRealty",
    iconName: "youtube-icon",
    className: "youtube-icon",
  },
];

export const CONTACT_DETAILS = {
  toll_free: "",
  email: "customer@savitarrealty.com",
  phone_number: "+91 99981 68022",
  address: "",
};

export const DAYS_OF_WEEK = [
  { label: "SUN", value: "sunday" },
  { label: "MON", value: "monday" },
  { label: "TUE", value: "tuesday" },
  { label: "WED", value: "wednesday" },
  { label: "THU", value: "thursday" },
  { label: "FRI", value: "friday" },
  { label: "SAT", value: "saturday" },
];

export const NOTIFICATION_DEVICE_TYPE = [
  { label: "Web", value: "web" },
  { label: "Android", value: "android" },
  { label: "Ios", value: "ios" },
];

export const MEETING_TOUR_STATUS: any = {
  0: { message: "Requested", status: "pending", value: 0 },
  1: { message: "Scheduled", status: "scheduled", value: 1 },
  2: { message: "Cancelled", status: "danger", value: 2 },
  3: { message: "Completed", status: "success", value: 3 },
};

export const LEAD_STATUS: any = {
  1: { message: "Initiated", status: "pending" },
  2: { message: "In Progress", status: "scheduled" },
  3: { message: "Deal Done", status: "success" },
  4: { message: "Deal Cancelled", status: "danger" },
  // 5: { message: "Completed", status: "success" },
};
export const PAYMENT_STATUS: any = {
  1: { message: "Token Received", status: "pending" },
  2: { message: "First Payment", status: "scheduled" },
  3: { message: "Half Payment", status: "scheduled" },
  4: { message: "Fully Paid", status: "success" },
};

export const NORMAL_STATUS: any = {
  0: {
    message: "In Active",
    status: "pending",
    icon: "Disable",
    className: "icon-primary",
  },
  1: {
    message: "Active",
    status: "success",
    icon: "Check",
    className: "icon-success",
  },
  2: {
    message: "Deleted",
    status: "danger",
    icon: "Disable",
    className: "icon-primary",
  },
};

export const NORMAL_SECOND_STATUS: any = {
  0: {
    message: "Un Published",
    status: "danger",
    icon: "Disable",
    className: "icon-primary",
  },
  1: {
    message: "Published",
    status: "success",
    icon: "Check",
    className: "icon-success",
  },
};

export const LEAD_PAYMENT_STATUS_LIST = [
  {
    label: "Token Receive",
    value: 1,
  },
  {
    label: "First Payment",
    value: 2,
  },
  {
    label: "Half Payment",
    value: 3,
  },
  {
    label: "Fully Paid",
    value: 4,
  },
];

export const LEAD_STATUS_LIST = [
  {
    label: "Pending",
    value: 1,
  },
  {
    label: "In Progress",
    value: 2,
  },
  {
    label: "Deal Closed",
    value: 3,
  },
  {
    label: "Cancelled",
    value: 4,
  },
];

export const PURCHASE_PURPOSE_LIST = [
  {
    label: "Resident",
    value: 1,
  },
  {
    label: "Investor",
    value: 2,
  },
];

export const PREDEFINE_TOUR_MESSAGE = [
  "What is the best time for you to show the property? Are weekend or evening tours available?",
  "How long will the tour take, and will we be able to see all areas of the property?",
  "Can I bring someone with me to the property tour, such as a friend or family member?",
  "Is it possible to schedule a virtual tour if I’m unable to visit in person?",
  "Are there any COVID-19 precautions or requirements for the in-person tour?",
  "Will you be able to provide detailed information about the property during the tour, such as its condition and recent updates?",
  "Is it possible to meet with the current owner or tenant during the tour for more insights about the property?",
  "Are there any other properties similar to this one that you could show me during the same visit?",
  "Can you provide me with a list of questions or key details I should consider during the tour?",
  "Would you be able to discuss the next steps if I’m interested in making an offer after the tour?",
  "Will I be able to take pictures or record videos during the tour for reference?",
  "If I have additional questions after the tour, will I be able to follow up with you directly?",
  "Other",
];

export const PREDEFINE_ENQUIRY_MESSAGE = [
  "Is the property still available? If so, how long has it been on the market?",
  "What is the asking price, and is it negotiable?",
  "Can you provide more details about the neighborhood and nearby amenities?",
  "Are there any recent renovations or upgrades done to the property?",
  "What is the current condition of the property? Any repairs or maintenance needed?",
  "What are the property taxes and any additional fees (e.g., HOA, maintenance)?",
  "How energy-efficient is the property? Are there any sustainability features?",
  "Can you share information about the local schools, public transportation, and shopping options?",
  "What are the financing options available for this property?",
  "Are there any restrictions or regulations I should be aware of (e.g., pet policies, rental rules)?",
  "Why is the owner selling, and how flexible are they with the closing date?",
  "Are there any other similar properties in this area that I might be interested in?",
  "Other",
];

export const PREDEFINE_REPORT_MESSAGE = [
  "Correct the inaccurate information in this listing.",
  "Remove duplicate listings for this property.",
  "Update the property images to match the description.",
  "Disclose any hidden damages or legal issues related to this property.",
  "Adjust the price to reflect the actual market value.",
  "Fix the incorrect contact details for the agent or owner.",
  "Correct the location details of this property.",
  "Mark this property as expired or unavailable if it’s no longer for sale.",
  "Investigate this listing for violations of app policies or legal regulations.",
  "Remove this property listing if it’s a scam or fraudulent.",
  "Investigate complaints about this property or agent from other users.",
  "Complete the missing information in this listing, such as square footage or property condition.",
  "Mark this property as sold or rented if it’s no longer available.",
  "Remove offensive or inappropriate content from this property listing.",
  "Other",
];

export const PROJECT_ENVIRONMENT = {
  ENV_LOCAL: "local",
  ENV_DEVELOPMENT: "development",
  ENV_STAGE: "stage",
  ENV_PRODUCTION: "production",
};

export const LOCAL_STORAGE_KEYS = {
  USER_ROLE: "userRole",
  USER_ID: "userId",
  ACCESS_TOKEN: "accessToken",
  REFRESH_TOKEN: "refreshToken",
  SELLER_TYPE: "sellerType",
  RELOAD_COUNT: "reloadCount",
  MANUAL_RELOAD: "manualReload",
  FILTER: "selectedFilter",
  MAP_DRAW: "mapDraw",
};

export const PROJECT_INFO_MENULIST: InfoMenuListOption[] = [
  {
    hrefId: "overview",
    label: "Overview",
    active: true,
  },
  {
    hrefId: "media_about",
    label: "Media & About",
    active: true,
  },
  {
    hrefId: "amenities",
    label: "Amenities",
    active: true,
  },
  {
    hrefId: "fact-features",
    label: "Fact & Features",
    active: true,
  },
  {
    hrefId: "floor-plan",
    label: "Floor Plan & Pricing",
    active: true,
  },
  {
    hrefId: "view-map",
    label: "Location Advantages",
    active: true,
  },
];

export const PROPERTY_INFO_MENULIST: InfoMenuListOption[] = [
  {
    hrefId: "overview",
    label: "Overview",
    active: true,
  },
  {
    hrefId: "media_about",
    label: "Media & About",
    active: true,
  },
  {
    hrefId: "amenities",
    label: "Amenities",
    active: true,
  },
  {
    hrefId: "fact-features",
    label: "Fact & Features",
    active: true,
  },
  {
    hrefId: "floor-plan",
    label: "Floor Plan",
    active: true,
  },
  {
    hrefId: "view-map",
    label: "Location Advantages",
    active: true,
  },
];

export const INTEREST_STATUS = [
  { label: "Full interested", value: 1 },
  { label: "Moderate interested", value: 2 },
  { label: "Low interested", value: 3 },
  { label: "Not interested", value: 4 },
];

export const sortingOptions = [
  {
    label: "Price (Low to High)",
    value: "price_asc",
  },
  {
    label: "Price (High to Low)",
    value: "price_desc",
  },
  {
    label: "Area (Low to High)",
    value: "total_area_asc",
  },
  {
    label: "Area (High to Low)",
    value: "total_area_desc",
  },
  {
    label: "Newest",
    value: "created_at_desc",
  },
  {
    label: "Oldest",
    value: "created_at_asc",
  },
];

export const propertyStatus = [
  {
    label: "Under Construction",
    value: 0,
  },
  {
    label: "Ready To Move",
    value: 1,
  },
];

export const FILTER_OPTIONS = {
  searchQuery: "",
  state_id: "",
  city_id: "",
  category_id: "",
  group: null,
  price: null,
  status: "",
  three_d: "",
  furnished_status: "",
  bedroom: null,
  totalArea: null,
  page: 1,
  limit: 50,
  sort_order: "",
  areas: [],
};

export const FACILITIES = {
  Education: {
    category: ["school", "university"],
    icon: "https://cdn-icons-png.flaticon.com/32/5193/5193783.png",
  },
  "Health Care": {
    category: ["hospital", "pharmacy"],
    icon: "https://cdn-icons-png.flaticon.com/32/3448/3448513.png",
  },
  Commute: {
    category: ["airport", "transit station"],
    icon: "https://cdn-icons-png.flaticon.com/32/5193/5193754.png",
  },
  "Food & Drinks": {
    category: ["restaurant"],
    icon: "https://cdn-icons-png.flaticon.com/32/3448/3448653.png",
  },
  Shopping: {
    category: ["shopping mall", "supermarket"],
    icon: "https://cdn-icons-png.flaticon.com/32/2606/2606919.png",
  },
  Temples: {
    category: ["hindu temple"],
    icon: "https://cdn-icons-png.flaticon.com/32/7931/7931009.png",
  },
  "Petrol Pump": {
    category: ["gas station"],
    icon: "https://cdn-icons-png.flaticon.com/32/3448/3448636.png",
  },
};

export const FloorPlanOptionList = [
  { label: "Lower", value: "lower" },
  { label: "Middle", value: "middle" },
  { label: "Upper", value: "upper" },
];
